import Components from "../components";
import moment from 'moment';

class TimelineSwitcher extends Components.Base {
  initialize() {
    this.lock = false; // Prevents multiple requests from being made at once.
    this.loadData($(this.$el.find('a.active')));
  }

  bind() {
    this.on('click', 'a', event => {
      event.preventDefault();
      this.loadData($(event.target));
    });
  }

  deinitialize() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  loadData(link) {
    if (!this.lock) {
      this.lock = true;
      const html = link.html();
      link.prepend('<i class="fa fa-refresh fa-spin"></i> ');
      this.xhr = $.ajax(
        `${link.attr('href')}&offset=${moment().utcOffset() * 60}`,
        {
          type: 'get',
          dataType: 'json',
          success: results => {
            const chart = this.$el.parent().find('.c-timeline-chart');
            const newData = results[0].data;

            // Set the current period in the chart data for tooltip formatting
            chart.data('period', link.data('period'));

            chart.data('plot').update({
              series: {
                data: newData,
              },
              xAxis: {
                min: newData[0][0],
                max: newData[newData.length - 1][0],
              },
            });

            // UI cleaup
            link.siblings().removeClass('active');
            link.addClass('active');
            link.html(html);

            // Persist the selection so the chart loads the same view when paging through notices
            $.cookie(
              chart.data('cookie') || 'faultTimelinePeriod',
              link.data('period'),
              { expires: 365, path: '/' },
            );
            this.lock = false;
          },

          error: (xhr, status) => {
            if (status !== 'abort') {
              this.$el.hide();
            }
            link.html(html);
            this.lock = false;
          },
        },
      );
    }
  }
}

Components.collection.register({
  selector: '.c-timeline-switcher',
  klass: TimelineSwitcher,
});
